var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 144,
    viewBox: "0 0 113 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.6153 105.845C44.5618 121.976 7.93013 139.593 4.62788 133.48C1.32564 127.367 16.8483 110.02 38.0921 89.2595C60.4675 67.3765 76.1923 61.1783 84.0014 63.5381C96.6446 67.4011 92.6576 89.7554 68.6153 105.845Z",
    fill: "#D4C962"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4657 61.6872C14.7734 90.8534 -4.17286 139.692 3.67338 143.131C11.2577 146.441 24.4997 124.427 52.6657 96.4914C80.1549 69.3098 112.05 33.3276 108.652 23.862C102.135 5.88194 64.2255 21.1816 35.4657 61.6872Z",
    fill: "#D4C962"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18675 141.129L3.49865 139.965C3.59148 139.619 3.6806 139.286 3.76972 138.954C3.95166 138.275 4.27947 137.605 4.53603 137.035C8.41916 128.08 16.63 120.967 24.9463 116.23C38.0912 108.642 52.6443 103.882 67.2781 100.095C74.4989 98.2275 81.7998 96.5597 89.0646 94.9714C95.1224 93.6241 101.773 90.9503 107.972 91.7349C114.17 92.5195 112.239 98.953 109.161 101.856C81.2248 128.161 37.635 116.213 11.1872 143.273C10.4263 144.064 7.60065 144.644 6.56896 145.006C3.97994 145.976 2.5761 143.298 3.18675 141.129Z",
    fill: "#F6DF8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41511 127.384C48.8205 54.5608 84.9373 39.1058 85.3625 38.9371L85.9216 40.3298C85.5651 40.4691 49.9123 55.7779 9.78541 128.089L8.41511 127.384Z",
    fill: "#F6DF8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8502 43.4109C100.278 39.3847 103.65 33.1836 101.381 29.5604C99.1114 25.9372 92.0609 26.264 85.6329 30.2902C79.2048 34.3165 75.8334 40.5176 78.1026 44.1408C80.3718 47.764 87.4222 47.4372 93.8502 43.4109Z",
    fill: "#F6DF8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryLeft);
export default __webpack_public_path__ + "static/media/gallery-left.70f6de552378ba4047ecaf17bc4e8f36.svg";
export { ForwardRef as ReactComponent };